import type { EvidenceProjectOption, ProjectSummary } from "@/types";

export function mapProjectSummaryToOption(project: ProjectSummary): EvidenceProjectOption {
  return {
    value: project.project_id,
    label: project.project_code,
    client: project.client_name,
    standard: project.standard_acronym,
    site: project.site_name,
    assets: project.assets,
    status: project.project_status,
  };
}

export function getDefaultProjectOption(
  projects: ProjectSummary[] | undefined
): EvidenceProjectOption | null {
  const firstProject = projects?.[0];

  return firstProject ? mapProjectSummaryToOption(firstProject) : null;
}

export function getProjectBreadcrumbs(
  project: Pick<EvidenceProjectOption, "label" | "standard" | "client" | "site"> | null
): string[] {
  return [project?.label, project?.standard, project?.client, project?.site].filter(
    (item): item is string => Boolean(item)
  );
}

export function getProjectAreas(
  project: Pick<EvidenceProjectOption, "assets" | "site"> | null
): string[] {
  if (project?.assets?.length) {
    return project.assets;
  }

  return project?.site ? [project.site] : [];
}
